export default {
  regionSelector: {
    chooseADisasterRegion: 'Select a disaster region',
    lastUpdate: 'Last update'
  }
}
